import { useSupportChat } from "~/composables/useSupportChat";

/**
 * Открыть поддержку внутри кабинета.
 *
 * Точки входа у кабинетов разные: у паблишера чат живёт модалкой (её
 * подключает layout), у рекламодателя — разделом «Диалоги» с выбранным
 * собеседником. Ссылка на телеграм-бота поддержки для этого не годится:
 * пользователь уходит из кабинета, а переписка не попадает в его тикеты.
 */
export const useSupportLink = (side: "advertiser" | "publisher" = "advertiser") => {
  const { openSC } = useSupportChat();

  const openSupport = () => {
    if (side === "publisher") {
      openSC();
      return;
    }
    navigateTo("/dialogs?to=support");
  };

  return { openSupport };
};
